module.exports = __webpack_public_path__ + "img/tiktok-colored.e5146055.svg";